
export default function Checkbox(props) {
    const checked = Boolean(props.value);

    return (
        <div className={props.containerClassName ? props.containerClassName : "relative flex items-center gap-2 sm:flex-col sm:gap-2 sm:-mt-2"}>
            <label htmlFor={props.name} className={props.labelClassName ? props.labelClassName : "text-sm font-medium text-gray-700 dark:text-gray-200 sm:w-fit sm:whitespace-nowrap"}>
                {props.label}
            </label>
            <input
                checked={checked}
                onChange={(event) => props.Idx !== undefined ? props.handleChange(props.name, event.target.checked, props.Idx) : props.handleChange(props.name, event.target.checked)}
                id={props.name}
                aria-describedby={`${props.name}-description`}
                name={props.name}
                type="checkbox"
                value={checked}
                className={props.className ? props.className : "focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded sm:self-center sm:mt-1"}
            />
        </div>
    )

}